module.exports = __webpack_public_path__ + "img/lang-picker-white.614cd30.png";